import React from 'react';
import { Skeleton } from 'antd';
import { useGetDataPoolIdentifiersQuery } from '../../../../features/vehicleModels/vehicleModelApi';
import { useCurrentCompany } from '../../../../features/company/companySlice';
import MatrixTable from './MatrixTable';
import ClassicTable from './ClassicTable';
import { useSelector } from 'react-redux';

export const VIEW_MODES = {
  LIST: 'Classic View',
  MATRIX: 'Matrix View'
};

const CompatibilityTable = ({
  loading,
  vehicleCompatibility,
}) => {
  const currentCompany = useCurrentCompany();
  const { data: dataPoolIdentifiers } = useGetDataPoolIdentifiersQuery({ companyId: currentCompany?.id }, { pollingInterval: 3600000, skip: currentCompany?.id === undefined });
  const viewMode = useSelector(state => state.vehicleModelFilter.viewMode);

  return loading
    ? <Skeleton active />
    : viewMode === VIEW_MODES.LIST
      ? <ClassicTable dataPoolIdentifiers={dataPoolIdentifiers} vehicleCompatibility={vehicleCompatibility} />
      : <MatrixTable dataPoolIdentifiers={dataPoolIdentifiers} vehicleCompatibility={vehicleCompatibility} />
};

export default CompatibilityTable;